import React from 'react'
import AppOfficesBlockContainer from "@components/DataBlocks/OfficesContainer"
import { Typography } from "@mui/material"


export default function officesColumn() {

	return [
		{
			name: 'pickUpFilters',
			label: 'Offices',
			options: {
				display: 'excluded',
				filterType: 'textField',
				customBodyRowRender: value => <Typography>{value}</Typography>,
			}
		}
		, {
			name: 'pickUp',
			label: 'Offices',
			options: {
				headerAlign: 'left',
				filter: false,
				customBodyRowRenderLite: value => <AppOfficesBlockContainer rows={value}/>,
			}
		}]
}